import { immerable } from 'immer';

export enum VersionSwitchBlockedReason {
	Authorization_paused = 'authorization-paused',
	VersionNotPublished = 'version-not-published',
	ProfileIncompatible = 'profile-incompatible',
	ProfileGone = 'profile-gone',
	AccessGone = 'access-gone',
	RepositoryRefused = 'repository-refused',
	NotInOffer = 'not-in-offer',
	None = 'none',
}

interface ISwitchableVersionProjectItemEntity {
	id: number;
	subscriptionLabel: string;
	consumerProjectId: number;
	consumerProjectLabel: string;
	consumerProjectVersion: string;
	profileLabel: string;
	currentProducerProjectId: number;
	currentProducerVersion: string;
	switchable: boolean;
	blockedReason: VersionSwitchBlockedReason;
}

const entityDefaults: ISwitchableVersionProjectItemEntity = {
	id: -1,
	subscriptionLabel: '',
	consumerProjectId: -1,
	consumerProjectLabel: '',
	consumerProjectVersion: '',
	profileLabel: '',
	currentProducerProjectId: -1,
	currentProducerVersion: '',
	switchable: false,
	blockedReason: VersionSwitchBlockedReason.None,
};

export class SwitchableVersionProjectItemEntity
	implements ISwitchableVersionProjectItemEntity
{
	private [immerable] = true;
	public id = entityDefaults.id;
	public subscriptionLabel = entityDefaults.subscriptionLabel;
	public consumerProjectId = entityDefaults.consumerProjectId;
	public consumerProjectLabel = entityDefaults.consumerProjectLabel;
	public consumerProjectVersion = entityDefaults.consumerProjectVersion;
	public profileLabel = entityDefaults.profileLabel;
	public currentProducerProjectId = entityDefaults.currentProducerProjectId;
	public currentProducerVersion = entityDefaults.currentProducerVersion;
	public switchable = entityDefaults.switchable;
	public blockedReason = entityDefaults.blockedReason;

	public static build(
		params: Partial<ISwitchableVersionProjectItemEntity> = {}
	): SwitchableVersionProjectItemEntity {
		const instance = new SwitchableVersionProjectItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.subscriptionLabel =
			params.subscriptionLabel ?? entityDefaults.subscriptionLabel;
		instance.consumerProjectId =
			params.consumerProjectId ?? entityDefaults.consumerProjectId;
		instance.consumerProjectLabel =
			params.consumerProjectLabel ?? entityDefaults.consumerProjectLabel;
		instance.consumerProjectVersion =
			params.consumerProjectVersion ?? entityDefaults.consumerProjectVersion;
		instance.profileLabel = params.profileLabel ?? entityDefaults.profileLabel;
		instance.currentProducerProjectId =
			params.currentProducerProjectId ??
			entityDefaults.currentProducerProjectId;
		instance.currentProducerVersion =
			params.currentProducerVersion ?? entityDefaults.currentProducerVersion;
		instance.switchable = params.switchable ?? entityDefaults.switchable;
		instance.blockedReason =
			params.blockedReason ?? entityDefaults.blockedReason;

		return instance;
	}
}
